import { rawData } from "../rawData";
import config from "../config.json";

const { dataSettings } = config;
const { uid } = dataSettings;

const getNamesOfParentTablesForItemsInCart = (arrayOfIds) => {
  const filteredData = rawData.filter((d) => arrayOfIds.includes(d[uid]));
  const listOfTableNamesWithPossibleRepeats = filteredData.map(
    (d) => d.table_name
  );
  const listOfTableNames = [];
  for (const tableName of listOfTableNamesWithPossibleRepeats) {
    if (!listOfTableNames.includes(tableName)) {
      listOfTableNames.push(tableName);
    }
  }
  return listOfTableNames;
};

export { getNamesOfParentTablesForItemsInCart };
